import { cn } from "@/lib/utils";

export const INPUT = "w-full bg-black/40 border border-jarvis-cyan/20 rounded-md px-3 py-2 text-sm font-code text-slate-100 placeholder:text-slate-600 focus:outline-none focus:border-jarvis-cyan/50";
export const BTN = "inline-flex items-center gap-2 min-h-10 px-4 rounded-md border font-mono text-[11px] uppercase tracking-wider transition-colors disabled:opacity-50";
export const BTN_PRIMARY = cn(BTN, "border-jarvis-cyan/50 text-jarvis-cyanBright bg-jarvis-cyan/10 hover:bg-jarvis-cyan/20");
export const BTN_GHOST = cn(BTN, "border-white/10 text-slate-400 hover:text-slate-200 hover:border-white/20");
export const BTN_DANGER = cn(BTN, "border-jarvis-red/40 text-jarvis-red hover:bg-jarvis-red/10");

export function ModulePage({ icon: Icon, title, subtitle, right, children, testId }) {
  return (
    <div className="h-full overflow-y-auto p-5 lg:p-6" data-testid={testId}>
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <Icon className="w-6 h-6 text-jarvis-cyan" />
          <div>
            <h1 className="font-mono text-xl lg:text-2xl uppercase tracking-[0.25em] font-bold text-jarvis-cyan jv-glow">{title}</h1>
            <p className="font-mono text-[11px] text-slate-500 tracking-widest" data-testid={`${testId}-subtitle`}>{subtitle}</p>
          </div>
        </div>
        {right}
      </div>
      {children}
    </div>
  );
}

export function Label({ children }) {
  return <label className="block font-mono text-[10px] uppercase tracking-wider text-slate-500 mb-1">{children}</label>;
}

export function Stat({ label, value, hint, tone = "cyan", testId }) {
  const color = { cyan: "text-jarvis-cyanBright", amber: "text-jarvis-amber", red: "text-jarvis-red", muted: "text-slate-500" }[tone];
  return (
    <div className="jv-panel p-4" data-testid={testId}>
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-1">{label}</div>
      <div className={cn("font-num text-2xl", color)}>{value}</div>
      {hint && <div className="font-mono text-[10px] text-slate-600 mt-1">{hint}</div>}
    </div>
  );
}

export function NotConnected({ children, testId }) {
  return (
    <div className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-1.5 rounded-md border border-jarvis-amber/30 bg-jarvis-amber/5 text-jarvis-amber" data-testid={testId}>
      <span className="w-1.5 h-1.5 rounded-full bg-jarvis-amber" />{children}
    </div>
  );
}

export function Empty({ children, testId }) {
  return <div className="jv-panel p-8 text-center font-mono text-xs text-slate-500 tracking-wider" data-testid={testId}>{children}</div>;
}

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const fmtNum = (n) => (n == null ? "—" : n.toLocaleString());
